<template>
  <div class="container">
    <van-cell
      class="header"
      :title="headTitle"
      title-class="title"
      :value="headAmount"
      value-class="value"
      center
    />
    <LongList
      :api-method="getData"
    >
      <template #default="{list}">
        <CommonTable
          v-if="list && list.length"
          class="table"
        >
          <tr>
            <th>
              日期
            </th>
            <th>
              商家参与分成(元)
              <van-icon
                name="question-o"
                @click="showTip=true"
              />
            </th>
            <th class="item">
              商家分成比例
            </th>
            <th class="item">
              商家分成(元)
            </th>
          </tr>
          <tr
            v-for="(item,index) in list"
            :key="index"
          >
            <td
              class="like-a"
              @click="onClickDate(item)"
            >
              {{ item.cutDay }}
            </td>
            <td>
              {{ item.totalAmount }}
            </td>
            <td>
              {{ item.dividedProportion }}
            </td>
            <td>
              {{ item.dividedAmount }}
            </td>
          </tr>
        </CommonTable>
        <NoBillTips
          v-else
          msg="暂无数据"
        />
      </template>
    </LongList>
    <TipModal
      v-model="showTip"
      :title="tip.title"
      :msg="tip.msg"
    />
  </div>
</template>
<script>
import CommonTable from '@/components/CommonTable';
import { formatYearMonth, getMonth } from '@/util/filter';
import LongList from '@/components/LongList';
import TipModal from '@/components/TipModal';
import NoBillTips from '@/components/NoBillTips';
import Api from '@/api/bill';

export default {
  name: 'AgentActivityMonthBillDetail',
  components: {
    LongList, TipModal, CommonTable, NoBillTips,
  },
  filters: {
    formatYearMonth,
    getMonth,
    formatRatio(value) {
      const rate = Number(value / 100);
      return `${rate}%`;
    },
  },
  data() {
    const {
      billType, billMonth, id, poiId, poiName, cutMonth, amount,
    } = this.$route.query;
    return {
      billType,
      billMonth,
      id,
      poiId,
      poiName,
      cutMonth,
      amount,
      tip: { title: '商家参与分成', msg: '【商家参与分成】为扣除经营成本后商家参与分成的金额。' },
      showTip: false,
    };
  },
  computed: {
    headTitle() {
      const month = getMonth(this.cutMonth);
      return `${month}月 ${this.poiName || ''}`;
    },
    headAmount() {
      return `活动账单：${this.amount || 0}元`;
    },
  },
  methods: {
    getData(pageNum, pageSize) {
      const {
        billType, billMonth, id: agreementId, poiId, cutMonth,
      } = this;
      const params = {
        billType: Number(billType),
        billMonth,
        agreementId,
        poiId,
        cutMonth,
        pageNum,
        pageSize,
      };
      return Api.getAgentActivityMonthBill(params);
    },
    onClickDate(item) {
      const {
        billMonth, id, poiId,
      } = this;
      const { cutDay, billDay, dividedAmount: amount } = item;
      this.$router.push({
        name: 'AgentActivityDailyBillDetail',
        query: {
          billMonth,
          id,
          poiId,
          cutDay,
          billDay,
          amount,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  padding: 18px 16px;
  background: none;
  .title {
    text-align: left;
    font-weight: bold;
    font-size: 30px;
    color: black;
  }
  .value {
    font-size: 28px;
    color: black;
  }
}

.table {
  width: 100%;
  td {
    width: 25%;
  }
}

</style>
